const BASE_API_ROUTE = 'https://api.dropboxapi.com/2';

export const FILE_BASE_API_ROUTE = `${BASE_API_ROUTE}/files`;
